<!-- https://8es9hr.axshare.com/#p=%E6%96%B0%E5%A2%9E%E9%80%80%E4%BF%9D%E7%94%B3%E8%AB%8B&g=1 -->
<!-- 新增退保申請 -->
<template>
    <div class="row">
        <div class="col-12">
            <el-tabs type="border-card">
                <el-tab-pane label="基本資料">
                    <el-form label-position="top">
                        <el-form-item label v-if="id == 0">
                            <ListForm
                                :id="id"
                                labelPosition="top"
                                :recordToEdit="recordToEdit"
                                :formType="formType"
                                ref="memberGet"
                                class="listFormSet"
                            >
                                <div slot="footer" class="dialog-footer"></div>
                            </ListForm>
                        </el-form-item>
                        <!-- <el-form-item label="輸入申請人帳號">
                            <el-input v-model="account"
                                      placeholder="請輸入內容"
                                      style="width: 200px;"></el-input>
                            <el-button type="primary"
                                       plain
                                       class="ml10"
                                       @click="schMember(account)">確認</el-button>
                        </el-form-item>-->
                        <el-form-item label="確認申請人資料" v-if="show">
                            <el-button plain @click="goMember">開啟申請人個人資訊</el-button>
                            <table class="table table-bordered mb-0 mt10 info">
                                <tbody>
                                    <tr>
                                        <td>社號</td>
                                        <td>{{member.coopCode}}</td>
                                    </tr>
                                    <tr>
                                        <td>帳號</td>
                                        <td>{{member.account}}</td>
                                    </tr>
                                    <tr>
                                        <td>姓名</td>
                                        <td>{{recordToEdit.name}}</td>
                                    </tr>
                                    <tr>
                                        <td>性別</td>
                                        <td>{{member.gender}}</td>
                                    </tr>
                                    <tr>
                                        <td>證件號碼 (身分證/居留證等)</td>
                                        <td>{{recordToEdit.idNumber}}</td>
                                    </tr>
                                    <tr>
                                        <td>年齡</td>
                                        <td>{{recordToEdit.age}}</td>
                                    </tr>
                                    <tr>
                                        <td>出生年月</td>
                                        <td>{{$transferDate(recordToEdit.birthday)}}</td>
                                    </tr>
                                    <tr>
                                        <td>職業</td>
                                        <td>{{recordToEdit.job}}</td>
                                    </tr>
                                    <tr>
                                        <td>職稱</td>
                                        <td>{{recordToEdit.title}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </el-form-item>

                        <el-form-item label="申請方案" v-if="show">
                            {{sub.name}}
                            <br />
                            已繳互助費 : {{payment.payAmount || 0}}
                            <br />
                            應退互助費 : {{payment.backAmount || 0}}
                        </el-form-item>
                    </el-form>
                    <el-button
                        type="primary"
                        v-if="!isSubmit"
                        @click="saveMainEdit"
                        plain
                        :disabled="!show"
                    >暫存</el-button>
                    <el-button type="primary" v-if="!isSubmit && id !== 0" @click="submit">送出</el-button>
                    <el-button @click="back">取消</el-button>
                </el-tab-pane>
                <el-tab-pane label="申請結果">
                    <el-form label-position="top">
                        <el-form-item label="申請日期">{{$transferDate(recordToEdit.sendGenDate)}}</el-form-item>
                        <el-form-item label="協會送件日期">
                            <div class="date mt10">
                                <input
                                    type="text"
                                    class="min_go_date genSendDate1 genSendDate"
                                    placeholder="選擇日期"
                                    :disabled="true"
                                />
                                <span class="el-input__prefix">
                                    <i class="el-icon-date"></i>
                                </span>
                            </div>
                        </el-form-item>
                        <el-form-item label="協會送件郵局存根條碼">
                            <el-input v-model="recordToEdit.genSendCode" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item
                            label="退保申請狀態"
                        >{{
                            id && id != 0
                                ? underwriteStatusBack[recordToEdit.underwriteStatus] + '-' + recordToEdit.insurerStatus
                                : ''
                        }}</el-form-item>
                        <!--如果不是加保通過就不顯示-->
                        <el-form-item
                            v-if="recordToEdit.underwriteStatus === 3 "
                            label="退費狀態"
                        >{{refoundStatus[recordToEdit.refoundStatus]}}</el-form-item>
                        <el-form-item
                            label="退費金額"
                            v-if="recordToEdit.underwriteStatus === 3 "
                        >{{recordToEdit.backAmount}}</el-form-item>
                        <el-form-item label="補件狀態">{{addDocStatus[recordToEdit.needAddDoc]}}</el-form-item>
                        <el-form-item label="補件通知內容" v-if="recordToEdit.needAddDoc === 1">
                            {{addDocNotices[0].noticeData}}
                            <br />
                            {{addDocNotices[0].updateTime}}
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import { API } from "@/assets/config";
import ListForm from "@/components/ListForm.vue";
export default {
    name: "agent_surrenderroster_edit",
    components: {
        ListForm
    },
    data() {
        return {
            member: {},
            addDocStatus: {},
            underwriteStatusBack: {},
            cardSendStatus: {},
            refoundStatus: {},
            addDocNotices: [{ noticeData: "", updateTime: "" }],
            id:
                this.$route.params.subId == "new"
                    ? 0
                    : this.$route.params.subId,
            isSubmit: false,
            api: "coopInsPlanMemberApply",
            recordToEdit: {
                memberData: ""
            },
            sub: {},
            payment: {},
            setTimeKey: ["genSendDate"],
            account: this.$route.params.account || this.$route.query.account,
            show: false,
            formType: [
                {
                    label: "選擇申請人",
                    key: "memberData",
                    type: "chooseMember",
                    searchMember: false,
                    api: "coopInsPlanMember",
                    placeholder: "從參加名冊中選擇生效中的申請人",
                    filter: {
                        insPlanYearId: 0,
                        underwriteStatus: 1
                    },
                    query: {
                        insPlanMainCode: this.$route.params.code
                    },
                    columns: [
                        {
                            prop: "memberAccount",
                            label: "社員帳號"
                        },
                        {
                            prop: "name",
                            label: "社員姓名"
                        },
                        {
                            prop: "subName",
                            label: "申請子方案"
                        },
                        {
                            label: "核保狀態",
                            prop: "underwriteStatus",
                            renderFunction(h, scope, enumData) {
                                return h(
                                    "div",
                                    enumData.insPlanUnderwriteStatus[
                                        scope.row.underwriteStatus
                                    ]
                                );
                            }
                        }
                    ]
                }
            ]
        };
    },
    created() {
        this.getData();
    },
    watch: {
        "recordToEdit.memberData.memberAccount": {
            handler(newKey) {
                this.schMember(newKey, 0);
            }
        }
    },
    methods: {
        getData() {
            let url = API[this.api] + `?id=${this.id}`;
            url += `&insPlanMainCode=${this.$route.params.code}`;
            const thenCB = json => {
                this.recordToEdit = Object.assign(
                    {},
                    this.recordToEdit,
                    json.resultData.data
                );
                this.underwriteStatusBack =
                    json.resultData.enumData.insPlanUnderwriteStatusBack;
                this.cardSendStatus =
                    json.resultData.enumData.insPlanApplyCardSendStatus;
                this.refoundStatus =
                    json.resultData.enumData.insPlanApplyRefoundStatus;
                this.addDocStatus =
                    json.resultData.enumData.insPlanApplyAddDocStatus;
                this.isSubmit = json.resultData.data.isSubmit == 1;

                //補件通知
                this.addDocNotices = json.resultData.addDocNotices;

                if (this.id == 0) {
                    // chooseMember fitler 年度
                    this.formType[0].filter.insPlanYearId =
                        json.resultData.enumData.effectiveYear[0].id;
                } else if (this.recordToEdit.memberId) {
                    this.schMember(this.account, this.recordToEdit.memberId);
                }

                setTimeout(() => {
                    this.setTimeKey.forEach(item => {
                        if (json.resultData.data[item]) {
                            $(`.${item}`).val(
                                `${
                                    parseInt(json.resultData.data[item]) -
                                        1911 <
                                    100
                                        ? `0${parseInt(
                                              json.resultData.data[item]
                                          ) - 1911}${
                                              json.resultData.data[item]
                                                  .slice(4)
                                                  .split(" ")[0]
                                          }`
                                        : `${parseInt(
                                              json.resultData.data[item]
                                          ) - 1911}${
                                              json.resultData.data[item]
                                                  .slice(4)
                                                  .split(" ")[0]
                                          }` || ""
                                }`
                            );
                        }
                    });
                }, 1);
            };
            this.mAxiosGet(url, thenCB);
        },
        schMember(memberAccount = "-1", memberId = 0) {
            this.show = false;
            let memberAPi =
                API.coopInsPlanMember +
                `?action=getPlanByMember&memberId=${memberId}&memberAccount=${memberAccount}&insPlanMainCode=${this.$route.params.code}&insPlanMemberApplyId=${this.id}`;
            const thenCB = json => {
                let memberData = json.resultData.enumData.member;
                this.member = memberData;

                this.account = json.resultData.enumData.member.account;
                this.show = true;
                this.sub = json.resultData.enumData.sub;
                this.payment = json.resultData.enumData.payment;
                this.payment.backAmount =
                    json.resultData.enumData.memberBackAmount;

                this.recordToEdit.memberId = json.resultData.data.memberId;
                this.recordToEdit.name = memberData.name;
                this.recordToEdit.sex = memberData.sex;
                this.recordToEdit.idNumber = memberData.idNumber;
                this.recordToEdit.birthday = memberData.birthday;
                this.recordToEdit.age = memberData.age;
                this.recordToEdit.title = memberData.jobTitle;
                this.recordToEdit.job = memberData.job;
                this.recordToEdit.insPlanMainCode =
                    json.resultData.data.insPlanMainCode;
                this.recordToEdit.insPlanYearId =
                    json.resultData.data.insPlanYearId;
                this.recordToEdit.insPlanSubId =
                    json.resultData.data.insPlanSubId;
            };
            this.mAxiosGet(memberAPi, thenCB);
        },
        async submit() {
            // 先 await 暫存，避免 update 與 submit 並行造成 race
            try {
                await this.saveMainEdit({ silent: true });
            
                let url = API.coopInsPlanMemberApply + `?action=submit`;
                let form = new FormData();
                form.append("id", this.id);
                await this.mAxiosPost(url, form);

				this.showAjaxSuccessMsg();
				this.getData();
			} catch (error) {
				console.error(error);
			}
        },
        async saveMainEdit(options = {}) {
            const silent = options.silent === true;
            let url = API.coopInsPlanMemberApply;
            let form = this.buildMainFormData();
            if (this.id !== "new" && this.id !== 0 && this.id) {
                form.append("id", this.id);
                url += `?action=update`;
            } else {
                url += `?action=append`;
            }

            const json = await this.mAxiosPost(url, form);
            this.id = json.resultData.id;
            if (!silent) {
                this.showAjaxSuccessMsg();
                this.$router.push({
                    name: this.$route.name,
                    params: { subId: json.resultData.id }
                });
                this.getData();
            }
            return json;
        },
        buildMainFormData() {
            let form = new FormData();

            form.append("insPlanMainCode", this.recordToEdit.insPlanMainCode || this.$route.params.code);
            form.append("insPlanSubId", this.recordToEdit.insPlanSubId);
            form.append("insPlanYearId", this.recordToEdit.insPlanYearId);
            form.append("memberId", this.recordToEdit.memberId);

            // 退保applyType 固定為3
            form.append("applyType", 3);

            form.append("name", this.recordToEdit.name || "");
            form.append("sex", this.recordToEdit.sex || "");
            form.append("idNumber", this.recordToEdit.idNumber || "");
            // 統一預設值，避免後端數值/日期轉型報錯
            form.append("birthday", this.recordToEdit.birthday || "");
            form.append("age", this.recordToEdit.age || 0);
            form.append("title", this.recordToEdit.title || "");
            form.append("job", this.recordToEdit.job || "");

            return form;
        },
        goMember() {
            const { href } = this.$router.resolve({
                name: "member_edit",
                params: {
                    id: this.recordToEdit.memberId
                }
            });
            window.open(href, "_blank", "toolbar=yes, width=1300, height=900");
        },
        back() {
            this.$router.push({
                name: "agent_surrenderroster"
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.listFormSet ::v-deep {
    .block-content {
        padding: 0;
    }
}
</style>